exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".infl-fe__style__disabledLink___1qqSC {\n  color: #B5BBC2;\n  pointer-events: none;\n}\n\n  .infl-fe__style__disabledLink___1qqSC:hover,\n  .infl-fe__style__disabledLink___1qqSC:focus,\n  .infl-fe__style__disabledLink___1qqSC:active,\n  .infl-fe__style__disabledLink___1qqSC:visited {\n    color: #B5BBC2;\n    cursor: default;\n  }\n", ""]);

// Exports
exports.locals = {
	"disabledLink": "infl-fe__style__disabledLink___1qqSC"
};